import { usePermissionsStore } from './store.ts';
import { App } from '@vp/common/api';
import { computed } from 'vue';

const { PermissionLevel, PermissionKey } = App.Permission.UserPermission;

type PermissionLevel = App.Permission.UserPermission.PermissionLevel;
type PermissionKey = App.Permission.UserPermission.PermissionKey;

export const usePolicy = () => {
  const store = usePermissionsStore();

  const can = (action: PermissionLevel, permissionKey: PermissionKey) => {
    const grantedLevel = store.permissionsMap[permissionKey];
    if (grantedLevel == action) {
      return true;
    }

    return grantedLevel == PermissionLevel.Edit && action == PermissionLevel.Read;
  };

  const ensurePermissions = async () => {
    await store.loadPermissions();
  };

  const eventPolicy = computed(() => ({
    show: true,
    viewManualCloseoutSheet: can(PermissionLevel.Read, PermissionKey.CloseoutSheetManualTickets),
    editManualCloseoutSheet: can(PermissionLevel.Edit, PermissionKey.CloseoutSheetManualTickets),

    viewAutomaticCloseoutSheet: can(PermissionLevel.Read, PermissionKey.CloseoutSheetAccess),
    editAutomaticCloseoutSheet: can(PermissionLevel.Edit, PermissionKey.CloseoutSheetAccess),

    accessCloseoutSheet:
      can(PermissionLevel.Read, PermissionKey.CloseoutSheetManualTickets) || can(PermissionLevel.Read, PermissionKey.CloseoutSheetAccess),
  }));

  return {
    can,
    ensurePermissions,

    eventPolicy,
  };
};
